import { createFromIconfontCN } from '@ant-design/icons'
import IconFont from './iconfont'

export const MyIcon = createFromIconfontCN({
    scriptUrl: IconFont, // generated by iconfont.cn
})
